// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltip[data-v-5be6321d]{background-color:#fff;border:1px solid #f5f6f7;border-radius:6px;box-shadow:0 6px 10px 4px rgba(0,0,0,.15);color:#2f343f;color:var(--shade-600,#2f343f);cursor:default;display:block;font-size:1rem;font-weight:400;line-height:160%;max-width:min(100vw,620px);padding:.5rem 1rem;position:fixed;text-indent:0;transition-duration:.1s;-webkit-user-select:none;-moz-user-select:none;user-select:none;z-index:100}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
